export const ConsentFormEmail = 'consentForm_email';
export const ConsentFormPhoneNumber = 'consentForm_phone_number';
export const EstimateEmail = 'estimate_email';

export const getDeclineReasonValidationKey = (modalityId: string) =>
  `estimate_modality_decline_${modalityId}`;

export const getAdmSelOtherValidationKey = (questionId: string) =>
  `history_admission_select_other_${questionId}`;
